export default function NotFound() {
    return(
        <div>
            <p>404 - not found</p>
        </div>
    )
}